'use client';

import { EVariant } from './types.js';

// Limit number option user can select
var DEFAULT_LIMIT_SELECT_COUNT = 3;
// 1 character is ~ 6.8px => 7px
var DEFAULT_CHARACTER_WIDTH = 7;
// 1 item padding is 16px
var DEFAULT_PADDING_WIDTH = 16;
// other item (except first one) have margin-left 4px
var DEFAULT_MARGIN_WIDTH = 4;
// 1 item have border width 2px (left + right)
var DEFAULT_BORDER_WIDTH = 2;
// Remove icon button width is 24px with extra plus item (34px)
var DEFAULT_REMOVE_ICON_WIDTH = 88;
var DEFAULT_MOBILE_FIXED_HEIGHT = 206;
var DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR = 168;
var FIXED_WIDTH_OF_INPUT = 36;
// Job Function Level
var SELECT_CATE_LEVEL_PARENT = 0;
var SELECT_CATE_LEVEL_SUB = 1;
var DEFAULT_INPUT_STYLE = {
    arrowDownSize: {
        width: 24,
        height: 24
    },
    isTransparentBackground: false,
    limitDisplay: 3,
    variant: EVariant.PRIMARY,
    cssString: '',
    leftIcon: function (_props) {
        return null;
    },
    forceLimitDisplay: 0
};
// Default option item height in pixel is 40px
var DEFAULT_OPTION_ITEM_HEIGHT = 40;
// Min height of dropdown item in pixel: 240px
var DEFAULT_MIN_HEIGHT_OF_DROPDOWN = 240;
var DEFAULT_DROPDOWN_FOOTER_OPTIONS = {
    isEnableFooter: false,
    setElementVisible: function () { },
    onClickApply: function () { },
    onClickCancel: function () { },
    resetSelectedValue: function () { }
};
var DEFAULT_TEXT_OPTIONS = {
    headerLabel: 'Header',
    searchPlaceholder: 'Search',
    allText: 'All',
    maxLimitText: 'Limit reached!',
    removeAllText: 'Remove all',
    backText: 'Back',
    noResultText: 'No result',
    selectedCountText: '',
    selectAllText: '',
    primaryButtonText: '',
    subOptionText: ''
};
var DEFAULT_DROPDOWN_STYLE_OPTIONS = {
    width: '100%',
    marginTop: 0,
    isShowTooltip: false,
    primaryBtnType: 'primary',
    borderRadius: 6,
    delayTime: 0,
    isForceClose: false
};
var DEFAULT_SELECT_OPTIONS = {
    limitParentCount: DEFAULT_LIMIT_SELECT_COUNT,
    isSortAlphabet: false,
    isSingleSelect: false,
    isFilter: false,
    isStripFirstItem: false,
    limitFirstItemLength: 24
};

export { DEFAULT_BORDER_WIDTH, DEFAULT_CHARACTER_WIDTH, DEFAULT_DROPDOWN_FOOTER_OPTIONS, DEFAULT_DROPDOWN_STYLE_OPTIONS, DEFAULT_INPUT_STYLE, DEFAULT_LIMIT_SELECT_COUNT, DEFAULT_MARGIN_WIDTH, DEFAULT_MIN_HEIGHT_OF_DROPDOWN, DEFAULT_MOBILE_FIXED_HEIGHT, DEFAULT_MOBILE_FIXED_HEIGHT_WITHOUT_ERROR, DEFAULT_OPTION_ITEM_HEIGHT, DEFAULT_PADDING_WIDTH, DEFAULT_REMOVE_ICON_WIDTH, DEFAULT_SELECT_OPTIONS, DEFAULT_TEXT_OPTIONS, FIXED_WIDTH_OF_INPUT, SELECT_CATE_LEVEL_PARENT, SELECT_CATE_LEVEL_SUB };
//# sourceMappingURL=constants.js.map
